/**
 * Les routes poussées du lot de l'exécution d'une activité : celles qu'il fait passer sur le design
 * system.
 *
 * - `activity` : l'activité ouverte (`ActivityWrapperScreen`), avec sa correction et ses
 *   félicitations, qui n'ont pas de route à elles ;
 * - `sam-session` : la même page, Sam en plus (`SamSessionScreen`).
 *
 * Les deux **hors live seulement** (pas de `livesInLive`) : en live, l'activité est composée par
 * l'écran du live (`useStudentActivityView` + `<StudentActivityBody heading="inline">`), qui la pose
 * dans son volet ; tant que l'écran du live est l'ancien, l'activité en live reste l'ancienne.
 *
 * `congrats` n'est PAS inscrite : la route sert une quinzaine d'écrans de fin de l'ancien code
 * (absence, rattrapage, boutique, essai, contrôle…), que l'écran des ports ne sait pas rendre. Les
 * félicitations d'une activité sont une étape de son écran (hors live comme dans le live, où pousser
 * une route recouvrirait la séance) : la route garde son legacy, pour tous ses autres lecteurs.
 *
 * Une activité rouverte FINIE (`currentActivity.progressStatus` à `finished`, posé par les activités
 * faites, les réalisations et la messagerie) passe aussi sur le design system : l'écran de la route
 * la montre finie (`StudentFinishedActivity` : l'énoncé, la copie, la correction), comme l'ancien
 * `ActivityWrapperScreen` choisissait `ActivityFinishedScreen`.
 *
 * Un écran se charge à son premier rendu (`loadedOnRender`).
 */
import { loadedOnRender } from "../loadedOnRender"
import { type StudentSpaceRouteTable } from "../studentSpaceRouteTypes"

/* eslint-disable @typescript-eslint/no-require-imports */
export const activityRoutes: StudentSpaceRouteTable<"activity"> = {
    activity: loadedOnRender(() => require("./StudentActivityScreen").StudentActivityScreen, "StudentActivityScreen"),
    "sam-session": loadedOnRender(
        () => require("./StudentSamSessionScreen").StudentSamSessionScreen,
        "StudentSamSessionScreen"
    ),
}
/* eslint-enable @typescript-eslint/no-require-imports */
